import {BrowserModule, DomSanitizer} from '@angular/platform-browser';
import {ErrorHandler, NgModule, NgZone} from '@angular/core';
import {Events, IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';
//Plugin components
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
//Pages
//Providers
import {LoginProvider} from '../providers/login/login';


import {MyApp} from './app.component';

import {File} from '@ionic-native/file';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
import {IonicStorageModule} from "@ionic/storage";
import {ScreenOrientation} from "@ionic-native/screen-orientation";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {RestApiProvider} from '../providers/rest-api/rest-api';
import {TokenInterceptorModule} from "../interceptors/token-interceptor.module";
import {SessionExpiredInterceptorModule} from "../interceptors/session-expired-interceptor.module";
import * as moment from "moment";
import {FileTransfer} from "@ionic-native/file-transfer";
import {IonicImageCacheHelperProvider, IonicImageCacheModule} from 'ionic3-image-cache';
import {UniqueDeviceID} from "@ionic-native/unique-device-id";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {OneSignal} from '@ionic-native/onesignal';
import {PopoverComponent} from '../components/popover/popover';
import {EditarComentarioComponent} from '../components/editar-comentario/editar-comentario';
import {
  PopoverComentariosDeComentariosComponent
} from '../components/popover-comentarios-de-comentarios/popover-comentarios-de-comentarios';
import {
  EditarComentariosDeComentariossComponent
} from '../components/editar-comentarios-de-comentarioss/editar-comentarios-de-comentarioss';
import {ComentarComentarioComponent} from '../components/comentar-comentario/comentar-comentario';
import {CustomImageCacheHelperProvider} from '../classes/CustomImageCacheHelperProvider';
import { PipesModule } from '../pipes/pipes.module';

import { IonicImageViewerModule } from 'ionic-img-viewer';



//Clases

moment.locale('es');

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    MyApp,
    PopoverComponent,
    EditarComentarioComponent,
    PopoverComentariosDeComentariosComponent,
    EditarComentariosDeComentariossComponent,
    ComentarComentarioComponent,
  ],
  imports: [
    BrowserModule,
    PipesModule,
    BrowserAnimationsModule,
    IonicImageViewerModule,
    IonicModule.forRoot(MyApp, {
      platforms: {
        ios: {
          backButtonText: '',
        }
      }
    }),
    IonicImageCacheModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    IonicStorageModule.forRoot(),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      }
    }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    PopoverComponent,
    EditarComentarioComponent,
    PopoverComentariosDeComentariosComponent,
    EditarComentariosDeComentariossComponent,
    ComentarComentarioComponent,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorModule, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: SessionExpiredInterceptorModule, multi: true},
    {
      provide: IonicImageCacheHelperProvider,
      useClass: CustomImageCacheHelperProvider,
      deps: [Events, FileTransfer, File, NgZone, DomSanitizer],
    },
    LoginProvider,
    ScreenOrientation,
    RestApiProvider,
    FileTransfer,
    UniqueDeviceID,
    OneSignal,
  ]
})

export class AppModule {
}




// WEBPACK FOOTER //
// ./src/app/app.module.ts